import React, {useState} from 'react';
import { Box, Divider, List, ListItemIcon, ListItemText } from '@mui/material';
import { Info, Settings, Preview } from '@mui/icons-material';
import { StyledAvatar, CommunityBasic, CommunityName, CommunityStatus, AvatarContainer, StyledListItem } from './styled';

const SideMenu = ({ slug, changeTab, avatar, title, subtitle }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
    changeTab(index);
  };

  const previewVenue = (slug) => {
    window.open('/venue/' + slug, '_blank');
  }
  return (
    <Box
      sx={{
        //width: '100%',
        //maxWidth: 240,
        //bgcolor: 'background.paper',
        //position: 'fixed',
        //height: '100vh',
        //overflow: 'auto',
      }}
    >
      <AvatarContainer>
        <StyledAvatar alt="Avatar" src={avatar} />
      </AvatarContainer>

      <CommunityBasic>
        <CommunityName>{title}</CommunityName>
      { subtitle ??  <CommunityStatus>{subtitle}</CommunityStatus>}
      </CommunityBasic>
      <Divider />
      <List>
      <StyledListItem selected={selectedIndex === 0} key={'bookings'} onClick={() => handleListItemClick(0)}>
        <ListItemIcon><Info /></ListItemIcon>
        <ListItemText primary='Bookings' />
      </StyledListItem>
      {/* <StyledListItem selected={selectedIndex === 1} key={'plans'} onClick={() => handleListItemClick(1)}>
        <ListItemIcon><Group /></ListItemIcon>
        <ListItemText primary='Plans' />
      </StyledListItem>*/}
      <StyledListItem selected={selectedIndex === 5} key={'manage'} onClick={() => handleListItemClick(5)}>
        <ListItemIcon><Settings /></ListItemIcon>
        <ListItemText primary='Manage' /> 
      </StyledListItem>
      <StyledListItem key={'preview'} onClick={() => previewVenue(slug)}>
        <ListItemIcon><Preview /></ListItemIcon>
        <ListItemText primary='View as user' /> 
      </StyledListItem>
      </List>
    </Box>
  );
};

export default SideMenu;
